<template>
    <span v-if="currentRouteName === 'Perangkat'">
      <router-link to="/riwayat/upload" class="btn btn-success mx-1"
        >Upload</router-link
      >
      <router-link to="/riwaat/unit" class="btn btn-success mx-1"
        >Unit</router-link
      >
    </span>
    <span>
      <router-view></router-view>
    </span>
  </template>
  
  <script>
  export default {
    name: "Riwayat-Index",
    computed: {
      currentRouteName() {
        const path = this.$route.name;
        const pathing = path
          .split("/")
          .filter(function (e) {
            return e;
          })
          .join(" / ");
        return pathing;
      },
    },
  };
  </script>